/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloorPlanDto } from '../../models/floor-plan-dto';

export interface FloorPlanControllerFindByEventIdV1$Params {
  eventId: string;
}

export function floorPlanControllerFindByEventIdV1(http: HttpClient, rootUrl: string, params: FloorPlanControllerFindByEventIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FloorPlanDto>>> {
  const rb = new RequestBuilder(rootUrl, floorPlanControllerFindByEventIdV1.PATH, 'get');
  if (params) {
    rb.path('eventId', params.eventId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FloorPlanDto>>;
    })
  );
}

floorPlanControllerFindByEventIdV1.PATH = '/api/v1/floor-plan/event/{eventId}';
